import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions";
const surveySessionReducer = {
    reducers: {
        [actions.setAvailableSurveys]: (state, payload) => setSafe(state, ["available"], payload),
    },
    defaults: {},
};
export default surveySessionReducer;
